import React, { useState } from 'react';
import { Box, Typography, Card, Container } from '@mui/material';
import Button from '../Button';
import person1 from '../../Media/person-1.png';
import person2 from '../../Media/person-2.png';
import person3 from '../../Media/person-3.png';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import maleImg from '../../Media/male.jpg';
import femaleImg from '../../Media/female.jpg';

const FeedbackSection = () => {
  const testimonials = [
    {
      name: 'Alex Kouba',
      location: 'Calgary, AB',
      image: maleImg,
      feedback: "Was Great working with Rahim, he made the mortgage process very fast, and I was surprised by how he handled the rate options with the banks."
    },
    {
      name: 'Jessica Hoey',
      location: 'Edmonton, AB',
      image: femaleImg,
      feedback: "Rahim is one of the most personable, professional people I've ever had the pleasure of working with! My experience with him has been so easy and he makes me feel so at home during our dealings. Always and forever will recommend!"
    },
    {
      name: 'R K',
      location: 'Calgary, AB',
      image: maleImg,
      feedback: "I want to thank Rahim and his team for making this mortgage such an easy process. Rahim went straight to work after my phone call with him at about 10 pm and was pretty impressive how quickly they got this done! Super friendly and patient in explaining all steps (nervous as a first time home buyer). If you need a mortgage, do not hesitate to deal with Rahim. He will go above and beyond to help! Thank you again."
    },
    {
      name: 'Hilda ngeche',
      location: 'Vancouver, BC',
      image: femaleImg,
      feedback: "Knowledge is power and having someone who sacrifices time with patience to pass on such information is very essential. This is exactly what Rahim does. It is thanks to Rahim that we understood mortgage renewal process and more clarification on fixed and variable interests. So much that I didn't know. A great facilitator for mortgages. He does this with so much fun and peace of mind is guaranteed. Thank you for your support always. You are my go to person Rahim. Highly recommended!"
    },
    {
      name: 'Michelle Crossland',
      location: 'Toronto, ON',
      image: femaleImg,
      feedback: "If you need a mortgage, Rahim is your guy. I was so impressed with his ability to explain the mortgage renewal process to me, combined with his ability to make a very dry and intimidating topic fun. Rahim works with his clients' best interests in mind and it is without any hesitation that I would recommend him to others. Thanks Rahim! Responsiveness, Quality, Professionalism, Value."
    },
    {
      name: 'Katherine Walker',
      location: 'Calgary, AB',
      image: femaleImg,
      feedback: "Rahim and his team are amazing to work with. They were very efficient in helping us obtain a mortgage for our first home purchase. As first time home buyers we were clueless in regards to the process. Rahim was extremely patient and helpful."
    },
    {
      name: 'B Dhaliwal',
      location: 'Edmonton, AB',
      image: maleImg,
      feedback: "After a very recent move to the city, we were unsure if our mortgage would be approved. Luckily, our realtor recommended that we talk to Rahim. He was very efficient, talking us through the entire process step by step, explaining everything."
    },
    {
      name: 'Eric Stevens',
      location: 'Red Deer, AB',
      image: maleImg,
      feedback: "Rahim is Amazing!!! When all other Mortgage company's and Banks said no Rahim found a way. He was so accommodating even when I was working night shifts he would take my calls at funny hours and always responded quickly. I would highly recommend him to anyone and will be using him in the future."
    },
    {
      name: 'Orn H',
      location: 'Vancouver, BC',
      image: femaleImg,
      feedback: "Big Thanks to Rahim & his team. Rahim is very patient, approachable, knowledgable, he spent a lot of time with my first time buyer client. He explained every single detail. The whole team is such a pleasant to work with. If you are looking for someone who really cares about your client, he is the guy!"
    },
    {
      name: 'T N',
      location: 'Calgary, AB',
      image: maleImg,
      feedback: "Rahim has consistently done a fantastic job for myself and everyone we have referred him. He has saved me on deals where the situation was so difficult and complex, and has still gotten the job done on-time, every time. I would highly highly recommend him to any investor or home-buyer."
    },
    {
      name: 'Alisha Rawji',
      location: 'Toronto, ON',
      image: femaleImg,
      feedback: "When I was looking to buy or rent a place I was very confused and overwhelmed about what option would be best for me. I've had many in depth conversations with Rahim about this, and he really took the time to explain the pros and cons of each option."
    },
    {
      name: 'Gloria Kwan',
      location: 'Calgary, AB',
      image: femaleImg,
      feedback: "Rahim and Kayla helped my partner and I to get the best rate possible during the crazy rate increase. They were quick to respond and walked us through the process. Will definitely recommend this amazing team for your mortgage needs. Thanks Rahim and Kayla for all your help and work!"
    },
    {
      name: 'Sheena Poonawala',
      location: 'Edmonton, AB',
      image: femaleImg,
      feedback: "Working with Rahim has been an absolute pleasure! I can't even describe how grateful I am. This was my first home purchase, needless to say I was confused and nervous and all over the place - well to be honest, that is just me in a nutshell. Rahim made it easy."
    },
    {
      name: 'Craig Rochelle-Ann Thomas',
      location: 'Calgary, AB',
      image: maleImg,
      feedback: "Raheim took us on as clients when we were at the lowest point of our home buying journey. He was so kind and reassuring. He never judged us based on our financial situation, He just took our information and went to work. He was honest about the process and He made it happen! He has an excellent team. Thanks Raheim and Dale."
    },
    {
      name: 'Clayton Glover',
      location: 'Edmonton, AB',
      image: maleImg,
      feedback: "Rahim is absolutely a great connection to help you handle all your mortgage needs. He really makes a typically frustrating experience both fun and painless!! Thank you Rahim!"
    },
    {
      name: 'Kirsten Joan',
      location: 'Calgary, AB',
      image: femaleImg,
      feedback: "Rahim Virani is such a pleasure to work with. He made my husband and I feel empowered, educated and enthusiastic about our mortgage process. It is also refreshing and visible that Rahim is very passionate about his career path and helping others."
    },
    {
      name: 'Chloe Wong',
      location: 'Vancouver, BC',
      image: femaleImg,
      feedback: "Rahim is amazing to work with! He is friendly, professional, and made this whole process a breeze. He's very reliable and made it easy to trust him right from the beginning. I would recommend Rahim's services to everyone I know - it was an exceptional experience."
    },
    {
      name: 'Mia Santos',
      location: 'Toronto, ON',
      image: femaleImg,
      feedback: "I had the best experience with Rahim! He is so professional, extremely knowledgeable and offers advice that I knew I could trust. Rahim listened to all my concerns, wasn't pushy and gave me suggestions that was in my best interest. Will definitely recommend Rahim and this company to everyone I know, thanks again Rahim!"
    },
    {
      name: 'Sarah Karim',
      location: 'Calgary, AB',
      image: femaleImg,
      feedback: "I would have to say that Rahim really listens and helps get not only what you need but helps you see things that you didn't even know were possible! He is an incredibly innovative mortgage advisor who knows how to advise on the right timing to get the best out of the choices you make!"
    },
    {
      name: 'Az Za',
      location: 'Edmonton, AB',
      image: maleImg,
      feedback: "Rahim was wonderful! He took care of all of our needs and was excellent to work with! He ensured we got the best package that suited our needs, and was a joy to deal with!"
    },
    {
      name: 'Janeen Wetzstein',
      location: 'Calgary, AB',
      image: femaleImg,
      feedback: "Rahim's care and attention to making sure his clients have the best possible mortgage solution, understand their commitments and options, and have peace of mind to enjoy their home make him an amazing person and incredible mortgage broker."
    },
    {
      name: 'Jonathon Luimes',
      location: 'Edmonton, AB',
      image: maleImg,
      feedback: "Spoke with Rahim when my mortgage came up for renewal. He took the time to understand what I was looking to accomplish and his recommendation was in my best interest not his...novel concept."
    },
    {
      name: 'Shak Chaudhry',
      location: 'Calgary, AB',
      image: maleImg,
      feedback: "Dealt with him twice now! Rahim has been caring and compassionate each time! He is now my Go-to guy! Thanks for your persistence with everything!"
    },
    {
      name: 'Parin Jivraj',
      location: 'Toronto, ON',
      image: maleImg,
      feedback: "Excellent service. Always comes through even for complicated situations. Very polite, pleasant and understands his business very well. Top of my list for mortgage referrals."
    },
    {
      name: 'fernando povoa',
      location: 'Calgary, AB',
      image: maleImg,
      feedback: "Got me into a condo!, Thanks for great work Mr. Virani! I am quite content in my new condo! You understand money and finance and made it easy for me! Much Appreciated!"
    },
    {
      name: 'King Kida',
      location: 'Edmonton, AB',
      image: maleImg,
      feedback: "Personal and professional. These are the qualities you need in a mortgage broker. You need Rahim Virani. I know I did."
    },
    {
      name: 'Courtney Zachariassen',
      location: 'Calgary, AB',
      image: femaleImg,
      feedback: "Rahim was knowledgeable and patient regarding my questions. He really put my needs first!"
    }
  ];

  // useInView to control animate prop on the entire section
  const [ref, inView] = useInView({
    triggerOnce: false,
    rootMargin: '-50px 0px'
  });

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0, y: 50, rotate: 2 },
    visible: {
      opacity: 1,
      y: 0,
      rotate: 0,
      transition: { duration: 0.5, staggerChildren: 0.2, when: 'beforeChildren' }
    }
  };

  const titleVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: 'easeOut' } }
  };

  const textVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } }
  };

  const buttonVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5, delay: 0.4, type: 'spring', stiffness: 200, damping: 15 }
    }
  };

  // Interactive hover variants for cards (without box shadow)
  const cardHoverVariants = {
    hover: {
      scale: 1.03,
      transition: { duration: 0.3, ease: 'easeOut' }
    }
  };

  // Interactive hover for images
  const imageVariants = {
    hover: {
      scale: 1.1,
      rotate: 3,
      transition: { duration: 0.4, ease: 'easeOut' }
    }
  };

  // State to track hovered card (for the scrolling cards)
  const [hoveredCard, setHoveredCard] = useState(null);
  const handleCardHover = (index) => setHoveredCard(index);
  const handleCardHoverEnd = () => setHoveredCard(null);

  return (
    <Box
      component={motion.div}
      ref={ref}
      variants={containerVariants}
      initial="hidden"
      animate={inView ? 'visible' : 'hidden'}
      sx={{
        width: '100%',
        py: { xs: 6, md: 8 },
        px: { xs: 2, md: 0 },
        backgroundColor: '#F7F9FC',
        overflow: 'hidden'
      }}
    >
      <Box sx={{ maxWidth: '1200px', mx: 'auto', width: '100%' }}>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: { xs: 6, md: 8 },
            px: { xs: 2, md: 4 },
            paddingLeft: { md: '0px!important' }
          }}
        >
          {/* Left Grid */}
          <Box
            component={motion.div}
            variants={titleVariants}
            whileHover={{ scale: 1.02 }}
            sx={{
              flex: { xs: '1 1 100%', md: '0 0 30%' },
              maxWidth: { xs: '100%', md: '30%' }
            }}
          >
            <Typography
              component={motion.div}
              variants={titleVariants}
              initial="hidden"
              animate={inView ? 'visible' : 'hidden'}
              variant="h3"
              sx={{
                color: '#64B5F6',
                fontWeight: 'bold',
                fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                mb: 2,
                position: 'relative',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  left: 0,
                  bottom: -10,
                  width: '80px',
                  height: '4px',
                  background: 'linear-gradient(to right, #64B5F6, transparent)',
                  borderRadius: '2px'
                }
              }}
            >
              FEEDBACK FROM OUR HAPPY CLIENTS
            </Typography>

            <Typography
              component={motion.div}
              variants={textVariants}
              initial="hidden"
              animate={inView ? 'visible' : 'hidden'}
              sx={{
                color: '#666',
                mb: 4,
                lineHeight: 1.8,
                fontSize: '1rem'
              }}
            >
              We take pride in delivering exceptional service, and nothing speaks louder than the words of our satisfied

              clients. From timely communication to going the extra mile, our team consistently earns praise for professionalism, reliability, and outstanding results. Whether it's a small project or a large-scale collaboration, our clients appreciate the care and attention we bring to every detail. Their positive feedback and continued trust inspire us to keep raising the bar. Here's what some of them have to say about their experience with us.
            </Typography>

            <Box
              component={motion.div}
              variants={buttonVariants}
              initial="hidden"
              animate={inView ? 'visible' : 'hidden'}
              sx={{ textAlign: { xs: 'center', md: 'left' } }}
            >
              <Button
                href="https://g.page/r/CTSDYFPS7L8YEAE/review"
                target="_blank"
                rel="noopener noreferrer"
                variant="dark"
                aria-label="Leave a review for Mortgage Line on Google"
              >
                Leave a Review on Google
              </Button>

            </Box>
          </Box>

          {/* Right Grid - Continuous Scroll */}
          <Box
            sx={{
              flex: { xs: '1 1 100%', md: '0 0 70%' },
              maxWidth: { xs: '100%', md: '70%' },
              position: 'relative',
              overflow: 'hidden',
              display: 'flex',
              alignItems: 'center',
              '&::before': {
                content: '""',
                position: 'absolute',
                left: 0,
                top: 0,
                height: '100%',
                width: '5vw',
                background: 'linear-gradient(to right, #F7F9FC, transparent)',
                zIndex: 2,
                pointerEvents: 'none'
              },
              '&::after': {
                content: '""',
                position: 'absolute',
                right: 0,
                top: 0,
                height: '100%',
                width: '5vw',
                background: 'linear-gradient(to left, #F7F9FC, transparent)',
                zIndex: 2,
                pointerEvents: 'none'
              }
            }}
          >
            <Box
              sx={{
                display: 'flex',
                gap: 3,
                width: 'fit-content',
                animation: 'slide 60s linear infinite',
                '@keyframes slide': {
                  '0%': { transform: 'translateX(0)' },
                  '100%': { transform: 'translateX(calc(-100% / 2))' }
                },
                '&:hover': { animationPlayState: 'paused' }
              }}
            >
              {/* First set of cards */}
              {testimonials.map((testimonial, index) => (
                <motion.div
                  key={`orig-${index}`}
                  variants={cardHoverVariants}
                  initial="initial"
                  whileHover="hover"
                  animate={hoveredCard === index ? 'hover' : 'initial'}
                  onHoverStart={() => handleCardHover(index)}
                  onHoverEnd={handleCardHoverEnd}
                >
                  <Card
                    sx={{
                      width: { xs: '350px', md: '400px' },
                      aspectRatio: '16/9',
                      p: 2,
                      my: 4,
                      bgcolor: 'white',
                      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
                      borderRadius: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      flexShrink: 0,
                      transition: 'all 0.3s ease-in-out',
                      cursor: 'pointer',
                      overflowY: 'auto',
                      overflowX: 'hidden',
                      position: 'relative',
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '5px',
                        height: '0%',
                        backgroundColor: '#64B5F6',
                        transition: 'height 0.4s ease-in-out'
                      },
                      '&:hover::before': {
                        height: '100%'
                      }
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                      <Box
                        component="img"
                        src={testimonial.image}
                        alt={testimonial.name}
                        sx={{
                          width: '60px',
                          height: '60px',
                          objectFit: 'cover',
                          borderRadius: 4
                        }}
                      />
                      <Box>
                        <Typography
                          className="name-text"
                          sx={{
                            fontWeight: 'bold',
                            color: '#0056B3',
                            fontSize: '1.1rem',
                            mb: 0.5,
                            transition: 'color 0.3s ease-in-out'
                          }}
                        >
                          {testimonial.name}
                        </Typography>
                        <Typography
                          sx={{
                            color: '#666',
                            fontSize: '0.9rem'
                          }}
                        >
                          {testimonial.location}
                        </Typography>
                      </Box>
                    </Box>
                    <Typography
                      className="feedback-text"
                      sx={{
                        color: '#666',
                        lineHeight: 1.6,
                        fontSize: { xs: '0.7rem', md: '0.9rem' },
                        flexGrow: 1,
                        transition: 'color 0.3s ease-in-out',
                        position: 'relative',
                      }}
                    >
                      {testimonial.feedback}
                    </Typography>
                  </Card>
                </motion.div>
              ))}

              {/* Duplicate set for seamless looping */}
              {testimonials.map((testimonial, index) => (
                <motion.div
                  key={`dupe-${index}`}
                  variants={cardHoverVariants}
                  initial="initial"
                  whileHover="hover"
                  animate={
                    hoveredCard === index + testimonials.length ? 'hover' : 'initial'
                  }
                  onHoverStart={() => handleCardHover(index + testimonials.length)}
                  onHoverEnd={handleCardHoverEnd}
                >
                  <Card
                    sx={{
                      width: { xs: '350px', md: '400px' },
                      aspectRatio: '16/9',
                      p: 2,
                      my: 4,
                      bgcolor: 'white',
                      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
                      borderRadius: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      flexShrink: 0,
                      transition: 'all 0.3s ease-in-out',
                      cursor: 'pointer',
                      overflow: 'hidden',
                      position: 'relative',
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '5px',
                        height: '0%',
                        backgroundColor: '#64B5F6',
                        transition: 'height 0.4s ease-in-out'
                      },
                      '&:hover::before': {
                        height: '100%'
                      }
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                      <Box
                        component="img"
                        src={testimonial.image}
                        alt={testimonial.name}
                        sx={{
                          width: '60px',
                          height: '60px',
                          objectFit: 'cover',
                          borderRadius: 4
                        }}
                      />
                      <Box>
                        <Typography
                          className="name-text"
                          sx={{
                            fontWeight: 'bold',
                            color: '#0056B3',
                            fontSize: '1.1rem',
                            mb: 0.5,
                            transition: 'color 0.3s ease-in-out'
                          }}
                        >
                          {testimonial.name}
                        </Typography>
                        <Typography
                          sx={{
                            color: '#666',
                            fontSize: '0.9rem'
                          }}
                        >
                          {testimonial.location}
                        </Typography>
                      </Box>
                    </Box>
                    <Typography
                      className="feedback-text"
                      sx={{
                        color: '#666',
                        lineHeight: 1.6,
                        fontSize: { xs: '0.7rem', md: '0.9rem' },
                        flexGrow: 1,
                        transition: 'color 0.3s ease-in-out'
                      }}
                    >
                      {testimonial.feedback}
                    </Typography>
                  </Card>
                </motion.div>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FeedbackSection;
// FeedbackSection.js
